import { render } from "./TaskDetailComponent.vue?vue&type=template&id=a171665c&scoped=true"
import script from "./TaskDetailComponent.vue?vue&type=script&lang=js"
export * from "./TaskDetailComponent.vue?vue&type=script&lang=js"

import "./TaskDetailComponent.vue?vue&type=style&index=0&id=a171665c&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a171665c"]])

export default __exports__